import { z } from 'zod';

export const documentSchema = z.object({
  idDocument: z.number(),
  Data: z.string().optional(),
  FileName: z.string(),
  idMIMEType: z.number(),
  Created_at: z.string(),
  idDocumentDirectory: z.number().nullable(),
  idLegalTransaction: z.number().nullable(),
  perEmail: z.boolean().optional().default(false).nullable(),
  isFromTemplate: z.boolean().optional().default(false).nullable(),
});

export type IDocument = z.infer<typeof documentSchema>;
